<template>
	<v-dialog v-model="organizationEmailDialog" max-width="500">
		<v-card>
			<v-card-title class="headline">Podany e-mail już istnieje w systemie</v-card-title>

			<v-card-text>Podany e-mail organizacji został już zarejestrowany w systemie.</v-card-text>

			<v-card-actions>
				<v-spacer></v-spacer>

				<v-btn color="green darken-1"
					flat="flat"
					@click="$emit('close')">
					Ok
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		name: "organization-with-this-email-exists-dialog",
		props: {
			organizationEmailDialog: {},
		},
	};
</script>
